export default {
	title: "Rituals",
	dateTime: "Date & Time",
	notFinished: "Not finished",
	edit: "Edit Ritual",
	create: "Create Ritual",
	notFound: "Ritual not found",
	loading: "Loading ritual...",
	createdBy: "Created by",
	deleteConfirmation: "Do you really want to delete the ritual {title}?",
	deleteWarning: "All tickets, returns and messages linked to this ritual will be permanently deleted.",
	deleteCodeInstruction: "To confirm, type the code {code}:",
	startWarning: "Once started, tickets can be distributed and called.",
	startCodeInstruction: "To confirm, type the code {code}:",
	status: {
		label: "Status",
		scheduled: "Scheduled",
		inProgress: "In Progress",
		in_progress: "In Progress",
		completed: "Completed",
		cancelled: "Cancelled",
		closed: "Closed",
	},
	form: {
		titleLabel: "Ritual Title",
		titleHint: "Title that identifies the ritual",
		descriptionLabel: "Description",
		descriptionHint: "Detailed description of the ritual",
		ritualTypeLabel: "Ritual Type",
		ritualTypeHint: "Select the ritual type",
		statusLabel: "Status",
		statusHint: "Current status of the ritual",
		dateLabel: "Date",
		dateHint: "Date when the ritual will take place",
		startTimeLabel: "Start Time",
		startTimeHint: "Ritual start time (required)",
		startDateLabel: "Start Date and Time",
		endDateLabel: "End Date and Time",
		locationLabel: "Location",
		locationHint: "Location where the ritual will take place",
		isPublicLabel: "Publish to public agenda",
		isPublicHint: "Makes this ritual visible on the temple's public page",
		acceptsReservationsLabel: "Accept reservations",
		acceptsReservationsHint: "Lets people reserve a spot for this ritual",
		publicNotesLabel: "Public notes",
		publicNotesHint: "Text shown on the public agenda (optional)",
		retroactiveWarning:
			"Past date: this ritual will be created as a retroactive entry. It starts as Scheduled — add the tickets and use \"Close Ritual\" to record it, without needing to start it.",
	},
	retroactive: {
		badge: "Retroactive entry",
	},
	table: {
		headers: {
			title: "Title",
			public: "Public",
		},
		public: {
			yes: "In public schedule",
			no: "Not published",
		},
		title: "Title",
	},
	tabs: {
		tickets: "Attendance Cards",
		stats: "Statistics",
		details: "Details",
		report: "Report",
		messages: "Messages",
		returns: "Returns",
	},
	lists: {
		pdf: "PDF",
		xlsx: "XLSX",
		sortCreated: "Creation order",
		sortTarget: "Target order",
		sortAlpha: "Alphabetical order",
		messagesEmpty: "No messages recorded for this ritual",
		returnsEmpty: "No returns linked to this ritual",
		groupEmpty: "No returns in this group",
		createdHere: "Created in this ritual",
		fulfilledHere: "Fulfilled in this ritual",
		markedHere: "Marked for this ritual",
		createdBy: "Created by",
	},
	actions: {
		delete: "Delete",
		start: "Start",
		complete: "Complete",
		cancel: "Cancel",
	},
	filters: {
		search: "Search rituals...",
		date: "Date",
		today: "Today",
		thisWeek: "This week",
		thisMonth: "This month",
		dateFrom: "Start date",
		dateTo: "End date",
		status: "Status",
		ritualType: "Ritual Type",
	},
	details: {
		ritualType: "Ritual Type",
		noTicketsDescription: "No attendance cards registered for this ritual",
	},
	messages: {
		created: "Ritual '{title}' created successfully",
		updated: "Ritual '{title}' updated successfully",
		deleted: "Ritual '{title}' deleted successfully",
		statusUpdated: "Ritual '{title}' status changed to {status}",
		createError: "Error creating ritual",
		updateError: "Error updating ritual",
		deleteError: "Error deleting ritual",
		statusUpdateError: "Error updating ritual status",
		loadError: "Error loading rituals",
		editDisabled: "Completed or cancelled rituals cannot be edited",
		deleteDisabled: "Cancelled, in progress or completed rituals cannot be deleted",
		cancelDisabled: "Cancelled or completed rituals cannot be cancelled",
		startDisabled: "Only scheduled rituals can be started",
	},
	confirmStatusChange: "Confirm Status Change",
	statusChangeConfirmation: "Are you sure you want to change the status of ritual '{title}' to {status}?",
	confirmations: {
		start: "Are you sure you want to start this ritual?",
		complete: "Are you sure you want to complete this ritual?",
		cancel: "Are you sure you want to cancel this ritual? This action cannot be undone.",
		delete: "Are you sure you want to delete the ritual '{title}'? This action cannot be undone.",
	},
	empty: {
		title: "No rituals found",
		subtitle: "Create the first ritual in the system",
		button: "Create Ritual",
		dependencyWarning: "To create rituals, you need to register attendance types and ritual types first.",
	},
	stats: {
		total: "Total",
		scheduled: "Scheduled",
		inProgress: "In Progress",
		completed: "Completed",
		cancelled: "Cancelled",
		acceptableLimit: "Limit (15 min)",
		attendanceTime: "Attendance Time per Station",
		avgTime: "Average time",
		loadError: "Error loading statistics",
		minutes: "minutes",
		noTickets: "No tickets registered for this ritual",
		noTicketsSubtitle: "Statistics will appear when tickets are distributed",
		pending: "Pending",
		perCardBreakdown: "Tickets per Attendance Station",
		statusDistribution: "Status Distribution",
		tickets: "tickets",
	},
	validation: {
		titleRequired: "Title is required",
		titleMaxLength: "Title must have at most 100 characters",
		ritualTypeRequired: "Ritual type is required",
		dateRequired: "Date is required",
		startTimeRequired: "Start time is required",
		locationMaxLength: "Location must have at most 200 characters",
		descriptionMaxLength: "Description must have at most 500 characters",
		publicNotesMaxLength: "Public notes must have at most 500 characters",
		activeRitualExists: "There is already a ritual in progress. Only one ritual can be active at a time.",
		invalidTime: "Invalid time format",
		statusRequired: "Status is required",
	},
};
